import {
  Box,
  CheckboxCard,
  CheckboxGroup,
  Highlight,
  Icon,
  Popover,
  Portal,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import { VIBES_TAGS } from '../../../containers/ListingPage/Sections/SectionVibeCheck';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const QUERY_KEY = 'pub_vibesTag';

const parseVibesFromUrl = search => {
  const params = new URLSearchParams(search);
  const raw = params.get(QUERY_KEY);

  if (!raw) return [];

  // expected format: has_any:premium,social
  const [, values] = raw.split(':');

  return values ? values.split(',') : [];
};

const formatVibesForUrl = values => (values.length ? `has_any:${values.join(',')}` : null);

const SearchFiltersVibes = ({ updateQueryParams }) => {
  const location = useLocation();

  // ---- LOCAL STATE (fast UI)
  const [selectedVibes, setSelectedVibes] = useState(() => parseVibesFromUrl(location.search));

  // ---- URL → STATE sync (back / forward / external updates)
  useEffect(() => {
    const fromUrl = parseVibesFromUrl(location.search);
    setSelectedVibes(fromUrl);
  }, [location.search]);

  // ---- STATE → URL
  const handleChange = values => {
    setSelectedVibes(values); // instant UI

    updateQueryParams({
      [QUERY_KEY]: formatVibesForUrl(values),
    });
  };

  return (
    <Box>
      <Box
        style={{ justifySelf: 'flex-end', justifyItems: 'flex-end' }}
        align={'end'}
        w={'max-content'}
        minW={0}
        textAlign={'right'}
      >
        <Popover.Root>
          <Popover.Trigger asChild>
            <Text
              mt={0}
              py={0}
              fontWeight={'semibold'}
              textDecoration={'underline'}
              textDecorationColor={'brand.600'}
              textDecorationThickness={'0.125rem'}
              textAlign={'right'}
            >
              What's this?
            </Text>
          </Popover.Trigger>
          <Portal>
            <Popover.Positioner>
              <Popover.Content>
                <Popover.Arrow />
                <Popover.Body>
                  <Popover.Title fontWeight="bold" color={'brand.600'}>
                    <span style={{ fontFamily: 'var(--footfallLogoFont)' }}>FootFall</span>
                    's Unique Blend
                  </Popover.Title>
                  <Text my={4}>
                    <Highlight
                      query={[
                        'quick',
                        'visual tags',
                        'feels',
                        'across',
                        'categories',
                        'expectations at',
                        'a glance',
                      ]}
                      styles={{ color: 'brand.600', bg: 'transparent', fontWeight: 'semibold' }}
                    >
                      Vibes are quick, visual tags that give you a sense of what a space feels like
                      before you visit. They work across categories and help set expectations at a
                      glance.
                    </Highlight>
                  </Text>
                </Popover.Body>
              </Popover.Content>
            </Popover.Positioner>
          </Portal>
        </Popover.Root>
      </Box>

      <CheckboxGroup value={selectedVibes} onValueChange={handleChange}>
        <SimpleGrid gap="2" columns={3}>
          {VIBES_TAGS.map(tag => (
            <CheckboxCard.Root
              align="center"
              key={tag.id}
              cursor="pointer"
              colorPalette={tag.colour}
              rounded={'xl'}
              value={tag.id}
              bgColor={selectedVibes?.includes(tag.id) ? 'gray.50' : ''}
            >
              <CheckboxCard.HiddenInput />
              <CheckboxCard.Control>
                <CheckboxCard.Content>
                  <Icon fontSize="2xl" mb="2">
                    {tag.icon}
                  </Icon>
                  <CheckboxCard.Label>{tag.label}</CheckboxCard.Label>
                  {/*<CheckboxCard.Description>{tag.tagline}</CheckboxCard.Description>*/}
                </CheckboxCard.Content>
              </CheckboxCard.Control>
            </CheckboxCard.Root>
          ))}
        </SimpleGrid>
      </CheckboxGroup>
    </Box>
  );
};

export default SearchFiltersVibes;
